import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <span className="text-xs font-label font-medium tracking-widest text-primary-600">
              FAQ
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-black text-foreground-950">
              常见问题
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              关于内容更新、线索投稿与信息核实，你可能关心的几个问题都在这里。
            </p>
            <a
              href="mailto:contact@chiguakanliao.com"
              className="mt-7 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-foreground-300 text-sm font-medium text-foreground-800 whitespace-nowrap cursor-pointer transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-mail-line" aria-hidden="true" />
              还有其他疑问？联系编辑
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q} className="reveal">
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="w-full flex items-start justify-between gap-5 py-5 text-left cursor-pointer group"
                      >
                        <span className="font-heading text-base md:text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                          {faq.q}
                        </span>
                        <span
                          className={`w-7 h-7 rounded-full shrink-0 flex items-center justify-center transition-colors ${
                            isOpen
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-100 text-foreground-600"
                          }`}
                          aria-hidden="true"
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <p className="pb-6 pr-10 text-sm md:text-base leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}